/**
 * Inline reservation widget entry.
 *
 * Mounts a Widget into every `[data-booking-widget]` element found in the host
 * page. See core.ts for the actual booking flow.
 *
 *   <script src="https://yourdomain.com/widget.js" async></script>
 *   <div data-booking-widget data-restaurant="my-slug"></div>
 */

import { Widget } from "./core";

function boot(): void {
  const mount = () => {
    document.querySelectorAll<HTMLElement>("[data-booking-widget]").forEach((host) => {
      if (host.dataset.bwInitialized === "1") return;
      host.dataset.bwInitialized = "1";
      new Widget(host);
    });
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mount, { once: true });
  } else {
    mount();
  }
}

boot();
